var $export = require('./$.export');

$export($export.S + $export.F, 'Object', {isObject: require('./$.is-object')});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.is-object.js
// module id = 1148
// module chunks = 0